module.exports = __webpack_public_path__ + "static/media/user-avatar.1f816109.png";